import { render, staticRenderFns } from "./ImsProfitLossEditTrade.vue?vue&type=template&id=2790795a&"
import script from "./ImsProfitLossEditTrade.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossEditTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports